import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as storageConstants from "../Constants/storageConstant";
import { PAGE_NOT_ACCESSABLE } from "../Constants/stringConstants";
import * as commonServices from "../Services/common";
import canAccessModule from "../Utils/permissionUtils";
import { warn } from "../Wrapper/toast/toast";

const ProtectedRoute = ({
  Component,
  configControl,
  pageName,
  moduleName,
  dropdownconfigControl,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = commonServices.getLocalData(storageConstants.AUTH);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
      return;
    } else if (isAuthenticated) {
      if (location.pathname === "/") {
        navigate(
          commonServices.isTherapist() || commonServices.isStaff() ? "/dashboard" : "/patients",
        );
      } else {
        let accessDenied = false;
        if (moduleName && !canAccessModule(moduleName)) {
          accessDenied = true;
        }
        if (!accessDenied && configControl && !commonServices.isConfigEnable(configControl)[0]) {
          accessDenied = true;
        }
        if (!accessDenied && dropdownconfigControl) {
          const dropdownOk = commonServices.isDropdownConfigEnable(dropdownconfigControl);
          if (dropdownOk === false) {
            accessDenied = true;
          }
        }
        if (!accessDenied && !commonServices.canAccessPage(pageName)) {
          accessDenied = true;
        }
        if (accessDenied) {
          if (location.pathname !== "/dashboard") {
            navigate("/dashboard");
            warn(PAGE_NOT_ACCESSABLE);
          }
        }
      }
    }
  }, [
    isAuthenticated,
    moduleName,
    pageName,
    location.pathname,
    navigate,
    configControl,
    dropdownconfigControl,
  ]);

  return <>{isAuthenticated || location.pathname === "/" ? Component : navigate("/")}</>;
};

export default ProtectedRoute;
